import { render, staticRenderFns } from "./FixedRentalSettings.vue?vue&type=template&id=55bc7b7f"
import script from "./FixedRentalSettings.vue?vue&type=script&lang=js"
export * from "./FixedRentalSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports